import { Box, Tooltip, Button, Flex } from '@chakra-ui/react';
import {
  RiBold,
  RiItalic,
  RiStrikethrough,
  RiH1,
  RiH2,
  RiH3,
  RiH4,
  RiParagraph,
  RiListOrdered,
  RiListUnordered,
  RiAlignRight,
  RiAlignLeft,
  RiLink,
  RiLinkUnlink,
} from 'react-icons/ri';
// import { ImageButton } from '@/ui/editor/ImageButton';
import { Link } from '@/ui/editor/Link';

const UnLink = ({ editor = {} }) => (
  <Button
    title="Unlink"
    bg="light.background"
    pb="19px"
    pl="10px"
    _hover={{ bg: 'light.background' }}
    onClick={() => editor?.chain()?.focus()?.unsetLink()?.run()}
  >
    <RiLinkUnlink
      size="16px"
      pb="20px"
      color={editor?.isActive('link') ? '#121314' : '#aaa'}
    />
  </Button>
);

function Toolbar({ editor }) {
  const toolbarCTAs = [
    {
      title: 'Bold',
      icon: RiBold,
      onClick: () => editor?.chain()?.focus()?.toggleBold()?.run(),
    },
    {
      title: 'Italic',
      icon: RiItalic,
      onClick: () => editor?.chain()?.focus()?.toggleItalic()?.run(),
    },
    {
      title: 'Strike',
      icon: RiStrikethrough,
      onClick: () => editor?.chain()?.focus()?.toggleStrike()?.run(),
    },
    {
      title: '',
      icon: RiH1,
      onClick: () =>
        editor?.chain()?.focus()?.toggleHeading({ level: 1 })?.run(),
    },
    {
      title: '',
      icon: RiH2,
      onClick: () =>
        editor?.chain()?.focus()?.toggleHeading({ level: 2 })?.run(),
    },
    {
      title: '',
      icon: RiH3,
      onClick: () =>
        editor?.chain()?.focus()?.toggleHeading({ level: 3 })?.run(),
    },
    {
      title: '',
      icon: RiH4,
      onClick: () =>
        editor?.chain()?.focus()?.toggleHeading({ level: 4 })?.run(),
    },
    {
      title: 'Align Left',
      icon: RiAlignLeft,
      onClick: () => editor?.commands?.setTextDirection?.('ltr'),
    },
    {
      title: 'Align Right',
      icon: RiAlignRight,
      onClick: () => editor?.commands?.setTextDirection?.('rtl'),
    },
    {
      title: 'Ordered List',
      icon: RiListOrdered,
      onClick: () => editor?.chain()?.focus()?.toggleOrderedList()?.run(),
    },
    {
      title: 'Unordered List',
      icon: RiListUnordered,
      onClick: () => editor?.chain()?.focus()?.toggleBulletList()?.run(),
    },
    {
      title: 'Paragraph',
      icon: RiParagraph,
      onClick: () => editor?.chain()?.focus()?.setParagraph()?.run(),
    },
    {
      title: 'Insert Link',
      icon: RiLink,
      Component: Link,
    },
    {
      title: 'UnLink',
      icon: RiLinkUnlink,
      Component: UnLink,
    },
    // {
    //   title: 'Insert Image',
    //   // icon: InsertImage,
    //   Component: ImageButton,
    // },
    // {
    //   title: 'Attach',
    //   icon: Attach,
    //   onClick: () => editor.chain().focus().toggleBold().run(), //TODO create a Attachment component
    // },
  ];

  const renderButton = ({ title, icon: IconComponent, onClick, Component }) => {
    return (
      <Tooltip
        label={title}
        arrowSize={8}
        hasArrow
        placement="top"
        borderRadius="4px"
      >
        {Component ? (
          <Component icon={IconComponent} editor={editor} />
        ) : (
          <Button
            onClick={onClick}
            bg="light.background"
            px="5px !important"
            py="0px !important"
            _hover={{
              bg: 'light.background',
            }}
          >
            <Box pb="5px">
              <IconComponent color="#121314" size="16px" pb="20px" />
            </Box>
          </Button>
        )}
      </Tooltip>
    );
  };

  return (
    <Flex flexWrap="wrap">
      {toolbarCTAs.map((action) => renderButton(action))}{' '}
    </Flex>
  );
}

export default Toolbar;
